(function () {
  // nur mobil
  function isMobile() {
    return window.matchMedia && window.matchMedia("(max-width: 990px)").matches;
  }

  // nur wenn Probo-UI überhaupt da ist (fallback: läuft trotzdem nicht aggressiv)
  function looksLikeProbo() {
    return !!document.querySelector('[class*="probo"], [id*="probo"], [data-probo], .probo-ui, #probo-ui');
  }

  let lastY = 0;
  let justNavigated = false;

  // Scrollposition merken, aber nur wenn der User wirklich scrollt
  window.addEventListener("scroll", function () {
    if (!isMobile()) return;
    lastY = window.scrollY || window.pageYOffset || 0;
  }, { passive: true });

  // Wenn der User auf "Weiter" / "Zurück" klickt, merken wir uns die Position und stellen sie nach dem Render wieder her
  document.addEventListener("click", function (e) {
    if (!isMobile()) return;
    if (!looksLikeProbo()) return;

    const btn = e.target && e.target.closest ? e.target.closest("button, a, [role='button']") : null;
    if (!btn) return;

    const t = (btn.textContent || "").replace(/\s+/g, " ").trim().toLowerCase();
    if (t === "weiter" || t === "zurück" || t.includes("in den warenkorb")) {
      lastY = window.scrollY || window.pageYOffset || 0;
      justNavigated = true;

      // nach kurzer Zeit (wenn der nächste Step gerendert wurde) zurückscrollen
      setTimeout(function () {
        if (!justNavigated) return;
        window.scrollTo({ top: lastY, behavior: "instant" });
      }, 150);

      setTimeout(function () {
        if (!justNavigated) return;
        window.scrollTo({ top: lastY, behavior: "instant" });
        justNavigated = false;
      }, 600);
    }
  }, true);

  // Zusätzlich: wenn die App selbst "nach oben" scrollt beim DOM-Update, fangen wir das ab
  const mo = new MutationObserver(function () {
    if (!isMobile()) return;
    if (!looksLikeProbo()) return;
    if (!justNavigated) return;

    // wenn es gerade gesprungen ist, wieder zurück
    const y = window.scrollY || window.pageYOffset || 0;
    if (y < Math.max(0, lastY - 50)) {
      window.scrollTo({ top: lastY, behavior: "instant" });
    }
  });

  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
